const recent = new Map<string, number>();

function keyOf(title: string, msg?: string) {
  return `${title}|${(msg||'').slice(0,120)}`;
}

// Simple toast fallback for when the toast system isn't available
function fallbackToast(type: string, title: string, msg?: string) {
  console.log(`[${type.toUpperCase()}] ${title}${msg ? `: ${msg}` : ''}`);
}

export const notify = {
  success: (title: string, msg?: string) => {
    // Try to use the global toast system if available
    if ((window as any).showToast) {
      (window as any).showToast({ type: 'success', title, message: msg });
    } else {
      fallbackToast('success', title, msg);
    }
  },
  info: (title: string, msg?: string) => {
    if ((window as any).showToast) {
      (window as any).showToast({ type: 'info', title, message: msg });
    } else {
      fallbackToast('info', title, msg);
    }
  },
  // Will collapse identical errors for 8s
  error: (title: string, msg?: string) => {
    if (msg === 'abort') return; // silent aborts
    const k = keyOf(title, msg);
    const now = Date.now();
    const last = recent.get(k) || 0;
    if (now - last < 8000) return;
    recent.set(k, now);
    
    if ((window as any).showToast) {
      (window as any).showToast({ type: 'error', title, message: msg });
    } else {
      fallbackToast('error', title, msg);
    }
  },
};